import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Define path/title patterns
const routeTitles = [
  { match: /^\/$/, title: 'Home' },
  { match: /^\/documentation/, title: 'Documentation' },
  { match: /^\/inbox/, title: 'Inbox' },
  { match: /^\/audittrail/, title: 'Audit Trail' },
  { match: /^\/configuration\/users/, title: 'Users' },
  { match: /^\/configuration\/roles/, title: 'Roles' },
  { match: /^\/configuration\/configitems/, title: 'Config Items' },
  { match: /^\/configuration\/tables/, title: 'Tables' },
  { match: /^\/configuration\/connections/, title: 'Connections' },
  { match: /^\/configuration\/workers/, title: 'Workers' },
  { match: /^\/configuration\/queues/, title: 'Queues' },
  { match: /^\/configuration\/zones/, title: 'Zones' },
  { match: /^\/configuration\/locks/, title: 'Locks' },
  { match: /^\/automation\/node_definitions/, title: 'Node Definitions' },
  { match: /^\/automation\/events/, title: 'Events' },
  { match: /^\/automation\/node_instances/, title: 'Node Instances' },
  { match: /^\/automation\/scheduling_window/, title: 'Scheduling Window' },
  {
    match: /^\/automation\/file_event_instances/,
    title: 'File Event Instances',
  },
  { match: /^\/automation\/event_instances/, title: 'Event Instances' },
  { match: /^\/reports\/definitions/, title: 'Report Definitions' },
  { match: /^\/reports\/run/, title: 'Run Report' },
  { match: /^\/node_editor/, title: 'Node Editor' },
  { match: /^\/instance_viewer/, title: 'Instance Viewer' },
  { match: /^\/node_instance_file/, title: 'Node File' },
  { match: /^\/node_submit/, title: 'Submit' },
  { match: /^\/node_update_instance/, title: 'Update Instance' },
  { match: /^\/node_resubmit/, title: 'Resubmit' },
  { match: /^\/login/, title: 'Login' },
  { match: /^\/callback/, title: 'Callback' },
  { match: /^\/logoff/, title: 'Logout' },
  { match: /^\/pages\/errors\/404/, title: '404 Not Found' },
  { match: /^\/pages\/errors\/403/, title: 'Access Denied' },
  { match: /^\/pages\/errors\/500/, title: 'Server Error' },
  { match: /^\/pages\/authentication\/simple\/sign-in/, title: 'Sign In' },
  { match: /^\/pages\/authentication\/simple\/sign-up/, title: 'Sign Up' },
  { match: /^\/pages\/authentication\/simple\/sign-out/, title: 'Sign Out' },
  {
    match: /^\/pages\/authentication\/simple\/forgot-password/,
    title: 'Forgot Password',
  },
  {
    match: /^\/pages\/authentication\/simple\/reset-password/,
    title: 'Reset Password',
  },
  {
    match: /^\/pages\/authentication\/simple\/lock-screen/,
    title: 'Lock Screen',
  },
  {
    match: /^\/pages\/authentication\/simple\/2FA/,
    title: 'Two-Factor Authentication',
  },
];

export default function useAutoPageTitle() {
  const location = useLocation();

  useEffect(() => {
    const baseTitle = 'Norscom Automation Portal';
    const currentPath = location.pathname;

    const matched = routeTitles.find((route) => route.match.test(currentPath));
    const pageTitle = matched ? matched.title : 'Norscom Automation Portal';

    document.title = matched ? `${pageTitle} | ${baseTitle}` : baseTitle;
  }, [location]);
}
